import React from "react";
import Link from "next/link";
import { excerpt } from "@unisearch/helpers/utils";
import SocialSharingLinks from "@modules/study/common/social_sharing_links";
import styles from "./news_thumb_card.module.scss";
import { getAssets } from "@unisearch/helpers";
const baseUrl = process.env.NEXT_PUBLIC_URL;
import BookmarkAction from "@unisearch/common/ui_element/actions/bookmark";
import { isReadingListed } from "@unisearch/helpers";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";

export const NewsThumbCard = ({ data, alignColumn, ...props }) => {
  const profileInfo = useRecoilValue(authAtom);

  let detailLink = `/news/${data?.newsFormat}/${data?.slug}`;
  if (data?.newsFormat == "standard") {
    detailLink = `/news/${data?.slug}`;
  }

  return (
    <div
      className={`${styles.news_thumb_card} 
      ${alignColumn ? styles.align_column : ""}`}
    >
      <div className={styles.news_feature_image_wrapper}>
        <Link legacyBehavior href={detailLink}>
          <a>
            <img
              src={
                data?.featureImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt={data?.featureImage?.alt || "Latest News"}
            />
          </a>
        </Link>
      </div>
      <div className={styles.news_body_wrapper}>
        <div className={styles.news_category}>
          {data?.category?.length > 0 && (
            <div>
              {data?.category?.map((cat, i) => {
                let catLink = `/news/${data?.newsFormat}/category?limit=8&page=1&category=${cat?.slug}&newsFormat=${data?.newsFormat}`;
                if (data?.newsFormat == "standard") {
                  catLink = `/news/category?limit=8&page=1&category=${cat?.slug}`;
                }
                return (
                  <Link legacyBehavior key={i} href={catLink}>
                    <a>
                      <span className={styles.category}>
                        {cat?.categoryName},{" "}
                      </span>
                    </a>
                  </Link>
                );
              })}
            </div>
          )}

          <BookmarkAction
            showText={false}
            customClasses={{
              root: styles.bookmark_root_class,
              btnClass: styles.bookmark_btn_class,
              btnActiveClass: styles.bookmark_btn_active_class,
            }}
            referance={"news"}
            referanceId={data?.newsId ? parseInt(data.newsId) : ""}
            is_bookmarked={isReadingListed(profileInfo, "news", data?.newsId)}
          />
        </div>
        <Link legacyBehavior href={detailLink}>
          <a>
            <h4 className={styles.news_title}>{data?.newsTitle}</h4>
          </a>
        </Link>
        <div className={styles.news_description}>
          {data?.shortDescription
            ? excerpt(data.shortDescription, 200)
            : data?.newsContent
            ? excerpt(data?.newsContent, 200)
            : ""}
        </div>
        <div className={styles.news_actions_wrapper}>
          <Link legacyBehavior href={detailLink}>
            <a className={`btn ${styles.btn_read_more}`}>Read More</a>
          </Link>

          <div className={styles.news_social_sharings}>
            <SocialSharingLinks
              className={styles.social_links}
              url={`${baseUrl}${detailLink}`}
              title={data?.newsTitle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsThumbCard;
